module.exports = __webpack_public_path__ + "img/4.957c8c8f.png";